import * as React from "react";
import {
  List, Datagrid, TextField,
  Show, SimpleShowLayout, TopToolbar, DeleteButton,
  TextInput, NumberInput, useRecordContext,
} from "react-admin";
import { Box, Rating } from "@mui/material";
import { JsonField } from "../../components/JsonField";
import { InfoGrid } from "../../components/InfoGrid";
import { TechInfo } from "../../components/ui";
import { UserRefField } from "../../components/ui";
import { FrDateField } from "../../components/FrDateField";

// ReviewDTO fields : id, idAuthor, idReceiver, titleReview, review, rating,
// date, overallRating, generalFeedback, specificRatings, characteristics,
// additionalComments. PAS de proId/patientId/comment/createdAt.
// Backend (ReviewController) : GET /reviews (liste admin), DELETE /reviews/{id}.
// Ni GET /{id} ni PUT : pas d'édition ni de masquage — suppression seule,
// fiche lue depuis la liste (getOneFromList).
const filters = [
  <TextInput key="idReceiver" source="idReceiver" label="ID destinataire (pro)" alwaysOn />,
  <NumberInput key="rating" source="rating" label="Note" />,
];

const StarsField = ({ source = "rating" }) => {
  const r = useRecordContext();
  if (!r) return null;
  return <Rating value={r[source] || 0} readOnly precision={0.5} size="small" />;
};

const ShowActions = () => (
  <TopToolbar>
    <DeleteButton mutationMode="pessimistic"
      confirmTitle="Supprimer cet avis"
      confirmContent="L'avis sera définitivement supprimé." />
  </TopToolbar>
);

export default {
  list: () => (
    <List filters={filters} sort={{ field: "date", order: "DESC" }}>
      <Datagrid rowClick="show">
        <FrDateField source="date" label="Date" />
        <UserRefField source="idAuthor" label="Auteur" />
        <UserRefField source="idReceiver" label="Destinataire" />
        <StarsField />
        <TextField source="titleReview" label="Titre" />
        <TextField source="review" label="Commentaire" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show actions={<ShowActions />}>
      <SimpleShowLayout>
        <InfoGrid
          fields={[
            { label: "ID", source: "id", type: "mono" },
            { label: "Auteur", source: "idAuthor", type: "mono" },
            { label: "Destinataire", source: "idReceiver", type: "mono" },
            { label: "Note", source: "rating" },
            { label: "Note globale", source: "overallRating" },
            { label: "Titre", source: "titleReview" },
            { label: "Commentaire", source: "review" },
            { label: "Feedback général", source: "generalFeedback" },
            { label: "Caractéristiques", source: "characteristics", type: "list" },
            { label: "Notes spécifiques (objet)", source: "specificRatings" },
            { label: "Commentaire additionnel", source: "additionalComments" },
            { label: "Date", source: (r) => r?.date ? new Date(r.date).toLocaleString("fr-FR") : "—" },
          ]}
        />
        <Box sx={{ mt: 2 }}><StarsField /></Box>
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};

